module.exports = __webpack_public_path__ + "img/montreal ex.f0f9216b.webp";